module.exports = __webpack_public_path__ + "images/emoji/oncoming_automobile.5dfe9cabb009e939cd29.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/oncoming_automobile.png
// module id = 5QNR
// module chunks = 2